// The session cookie is httpOnly and is issued by the API host, so the SPA cannot see it at all. This is the
// cockpit's own record that it last saw a live session, kept so the auth routes can skip a request for the
// anonymous visitors that make up nearly all of their traffic. It is a hint and only a hint: it is written by
// the client, so it proves nothing, and every route still confirms with the server before trusting it.

const STORAGE_KEY = 'houzy.partner-cockpit.has-session';

// Mirrors the session cookie's 7-day life. Re-stamped on every successful current-user fetch, so it slides with
// the cookie's own hourly refresh rather than going stale under an active partner.
const MAX_AGE_MS = 7 * 24 * 60 * 60_000;

export function rememberCockpitSession(): void {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ at: Date.now() }));
    } catch {
        // Storage can be unavailable; the auth routes then fall back to asking the server.
    }
}

export function hasCockpitSessionHint(): boolean {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const parsed: unknown = raw === null ? null : JSON.parse(raw);
        if (typeof parsed !== 'object' || parsed === null) {
            return false;
        }
        const { at } = parsed as { at?: unknown };
        return typeof at === 'number' && Date.now() - at <= MAX_AGE_MS;
    } catch {
        return false;
    }
}

// Called where a session turns out to be gone, so a JWT invalidated ahead of its expiry — a password or email
// change, a locked user — cannot leave a hint behind that keeps redirecting into an app that redirects back.
export function clearCockpitSessionHint(): void {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch {
        // As above; a stale hint costs one request, which the guard then acts on.
    }
}
